<template>
    <div class="pa-5" v-if="activeShipment">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShipment.company_name ? activeShipment.company_name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Shipment size" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeShipment.shipment_size ? t(getShipmentSizeText(activeShipment.shipment_size, activeShipment.direction)) : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Car nr" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShipment.vehicle_reg_number ? activeShipment.vehicle_reg_number : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Direction" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShipment.direction ? t(capitalizeFirstLetter(activeShipment.direction)) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShipment.status ? t(capitalizeFirstLetter(activeShipment.status)) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Created by" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShipment.created_by_display ? activeShipment.created_by_display : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShipment.comment ? activeShipment.comment : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <vuecal
                    :locale="vuecalLocale"
                    :events="shipments[this.activeShipment.direction]"
                    :disable-views="['years', 'year', 'day']"
                    hide-view-selector
                    show-week-numbers
                    hide-weekends
                    :snapToTime="snapToTime"
                    :time-from="timeFrom"
                    :time-to="timeToDisplay"
                    :time-step="30"
                    :time-cell-height="50"
                    :cell-click-hold="false"
                    :drag-to-create-event="false"
                    :events-on-month-view="'short'"
                    :editable-events="{ title: false, drag: true, resize: false, delete: false, create: false }"
                    :disable-days="disabledDates"
                    ref="vuecal"
                    @ready="onReady"
            >
                <template #event="{ event, view }">
                    <!-- Week View -->
                    <div @click="handleCalendarEventClick(event.id)"
                         :class="[
                              'existing-event',
                              `status-${event.status}`,
                              { 'current-event': event.id === activeShipment.id }
                            ]"
                         v-if="view === 'week'"
                    >
                        <div class="vuecal__event-title font-weight-bold company-name" v-html="event.title"></div>

                        <small class="vuecal__event-time">
                            <strong>{{ `${ t("Car nr") }:` }}</strong> <span>{{ event.vehicle_reg_number }}</span><br/>
                            <strong>{{ `${ t("Start") }:` }}</strong> <span>{{ event.start.formatTime("HH:mm") }}</span><br/>
                            <strong>{{ `${ t("End") }:` }}</strong> <span>{{ event.end.formatTime("HH:mm") }}</span>
                        </small>
                    </div>

                    <!-- Month View -->
                    <div @click="handleCalendarEventClick(event.id)"
                         :class="[
                              'month-event',
                              `status-month-${event.status}`,
                              { 'current-event-month': event.id === activeShipment.id }
                            ]"
                         v-else
                    >
                        <div>
                            <span class="company-name">{{ event.title }}: </span>
                            <span class="event-times">{{
                                    event.start.formatTime("HH:mm")
                                }}-{{ event.end.formatTime("HH:mm") }}</span>
                        </div>
                    </div>
                </template>

            </vuecal>
        </v-row>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { helperMixin } from "@/mixins/helper-mixin";
import moment from "moment";
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import holidays from './data-item/public-holidays.json';
import Store from "../../../store";

export default {
    mixins: [helperMixin],
    components: { vuecal: VueCal },
    data() {
        return {
            tab: 0,
            snapToTime: 15,
            timeFrom: 480,
            timeToDisplay: 960,
            events: []
        };
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("ShipmentStore", ["activeShipment", "shipments", "sizes", "vuecalLocale"]),
        disabledDates() {
            return Object.values(holidays).flatMap(year => Object.values(year));
        },
    },
    watch: {
        'activeShipment.id': {
            immediate: true,
            handler(oldId, newId) {
                if (!oldId !== newId) {
                    this.onReady()
                }
            }
        }
    },
    methods: {
        ...mapActions("ShipmentStore", ["getShipmentData"]),
        onReady() {
            setTimeout(() => {
                try {
                    this.$refs.vuecal.switchView('week', this.activeShipment.start);
                } catch (e) {
                    console.log(e)
                    setTimeout(() => {
                        this.$refs.vuecal.switchView('week', this.activeShipment.start);
                    }, 500)
                }
            }, 500);
        },
        getShipmentSizeText(shipment_size_id, direction) {
            const sizeOptions = this.sizes[direction] || {};
            const entry = Object.values(sizeOptions).find(option => option.id === shipment_size_id);
            return entry ? entry.text : null;
        },
        handleCalendarEventClick(shipmentId) {
            if (this.$route.name === "shipment-view" && parseInt(shipmentId) !== parseInt(this.$route.params.shipmentId)) {
                this.$router.push({ name: "shipment-view", params: { shipmentId: shipmentId } });
                this.getShipmentData(shipmentId)
            }
        }
    }
};
</script>

<style scoped>
.existing-event {
    border-radius: 6px;
    width: 98.5%;
    height: 99%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    cursor: pointer;
}

.month-event {
    text-align: left;
    padding-left: 0.3em;
    border-radius: 4px;
    width: 98.5%;
    height: 98%;
    margin-bottom: 2px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
}

.current-event {
    background: rgba(252, 37, 37, 0.15) !important;
}

.current-event-month {
    background: rgba(252, 37, 37, 0.15) !important;
}

.status-pending {
    background: rgba(252, 37, 37, 0.15);
}

.status-waiting {
    background: rgba(0, 123, 255, 0.15);
}

.status-done {
    background: rgba(40, 167, 69, 0.15);
}

.status-month-pending {
    background: rgba(252, 37, 37, 0.15);
}

.status-month-waiting {
    background: rgba(0, 123, 255, 0.15);
}

.status-month-done {
    background: rgba(40, 167, 69, 0.15);
}

.company-name {
    font-weight: bold;
    color: #3d3d3d;
}

.event-times {
    font-size: 0.9em;
    color: #555;
}

.vuecal__event-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

.vuecal__event-time {
    font-size: 12px;
    color: #666;
}
</style>
